import HomeApp from '../pages/HomeApp'
import AcompanharPedido from '../pages/AcompanharPedido'

import Categorias from '../../../pages/Categorias'
import InfoRestaurante from '../../../pages/InfoRestaurante'
import Pedidos from '../../../pages/Pedidos'
import Perfil from '../../../pages/Perfil'
import Notificacao from '../../../pages/Notificacao'
import PerfilDados from '../../../pages/PerfilDados'
import PerfilEndereco from '../../../pages/PerfilEndereco'
import PerfilEsqueceuSenha from '../../../pages/PerfilEsqueceuSenha'
import MeusCartoes from '../../../pages/MeusCartoes'
import NoLocal from '../../../pages/NoLocal'
import Finalizar from "../../../pages/Finalizar"
import Sacola from "../../../pages/Sacola"
import Promocoes from "../../../pages/Promocoes"
import Links from '../../../pages/Links'
import MeusPontos from '../../../pages/MeusPontos'
import MeusVouchers from '../../../pages/MeusVouchers'
import Pagamento from "../../../pages/Pagamento.vue";

export const unidadeRoutes = [
  {
    path: '/unidade',
    redirect: '/'
  },
  {
    path: '/unidade/:id',
    name: 'HomeUnidade',
    component: HomeApp,
    meta: { page: 'Home' }
  },
  {
    path: '/unidade/:id/categorias',
    name: 'CategoriasUnidade',
    component: Categorias,
    meta: { page: 'Categorias', title: 'Cardápio' }
  },
  {
    path: '/unidade/:id/info',
    name: 'InfoRestauranteUnidade',
    component: InfoRestaurante,
    meta: { page: 'InfoRestaurante', title: 'Empresa' }
  },
  {
    path: '/unidade/:id/sacola',
    name: 'SacolaUnidade',
    component: Sacola,
    meta: { page: 'Sacola', title: 'Sacola' }
  },
  {
    path: '/unidade/:id/promocoes',
    name: 'PromocoesUnidade',
    component: Promocoes,
    meta: { page: 'Promocoes', title: 'Promoções' }
  },
  {
    path: '/unidade/:id/finalizar',
    name: 'FinalizarUnidade',
    component: Finalizar,
    meta: { page: 'Finalizar', title: 'Finalizar' }
  },
  {
    path: '/unidade/:id/pedidos',
    name: 'PedidosUnidade',
    component: Pedidos,
    meta: { page: 'Pedidos', title: 'Meus Pedidos' }
  },
  {
    path: '/unidade/:id/perfil',
    name: 'PerfilUnidade',
    component: Perfil,
    meta: { page: 'Perfil', title: 'Perfil' }
  },
  {
    path: '/unidade/:id/notificacao',
    name: 'NotificacaoUnidade',
    component: Notificacao,
    meta: { page: 'Notificacao', title: 'Notificações' }
  },
  {
    path: '/unidade/:id/perfil/login',
    name: 'LoginUnidade',
    component: PerfilDados,
    meta: { page: 'Login', title: 'Login' }
  },
  {
    path: '/unidade/:id/perfil/cadastro',
    name: 'CadastroUnidade',
    component: PerfilDados,
    meta: { page: 'Cadastro', title: 'Cadastro' }
  },
  {
    path: '/unidade/:id/perfil/esqueci-senha',
    name: 'EsqueceuSenhaUnidade',
    component: PerfilEsqueceuSenha,
    meta: { page: 'EsqueceuSenha', title: 'Esqueci a Senha' }
  },
  {
    path: '/unidade/:id/perfil/enderecos',
    name: 'PerfilEnderecoUnidade',
    component: PerfilEndereco,
    meta: { page: 'PerfilEndereco', title: 'Meus Endereços' }
  },
  {
    path: '/unidade/:id/perfil/meus-dados',
    name: 'MeusDadosUnidade',
    component: PerfilDados,
    meta: { page: 'MeusDados', title: 'Meus Dados' }
  },
  {
    path: '/unidade/:id/perfil/telefone',
    name: 'TelefoneUnidade',
    component: PerfilDados,
    meta: { page: 'Telefone', title: 'Meu Telefone' }
  },
  {
    path: '/unidade/:id/perfil/meus-pontos',
    name: 'MeusPontosUnidade',
    component: MeusPontos,
    meta: { page: 'MeusPontos', title: 'Meus Pontos' }
  },
  {
    path: '/unidade/:id/perfil/meus-vouchers',
    name: 'MeusVouchersUnidade',
    component: MeusVouchers,
    meta: { page: 'MeusVouchers', title: 'Meus Vouchers' }
  },
  {
    path: '/unidade/:id/perfil/meus-cartoes',
    name: 'MeusCartoesUnidade',
    component: MeusCartoes,
    meta: { page: 'MeusCartoes', title: 'Meus Cartões' }
  },
  {
    path: '/unidade/:id/home/nolocal',
    redirect: '/unidade/:id/nolocal'
  },
  {
    path: '/unidade/:id/nolocal',
    name: 'NoLocalUnidade',
    component: NoLocal,
    meta: { page: 'NoLocal', title: 'Pedido no Local' }
  },
  {
    path: '/unidade/:id/fidelidade',
    name: 'FidelidadeUnidade',
    component: Promocoes,
    meta: { page: 'Fidelidade', title: 'Fidelidade' }
  },
  {
    path: '/unidade/:id/links',
    name: 'LinksUnidade',
    component: Links,
    meta: { page: 'Links', title: 'Links' }
  },
  {
    path: '/unidade/:id/acompanhar/:pedido',
    name: 'AcompanharUnidade',
    component: AcompanharPedido,
    meta: { page: 'Acompanhar', title: 'Acompanhar Pedido' }
  },
  {
    path: '/unidade/:id/pagamento/:pedido',
    name: 'PagamentoUnidade',
    component: Pagamento,
    meta: { page: 'Pagamento', title: 'Pagamento' }
  },
]
